var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-num"},[_c('div',{staticClass:"fix"},_vm._l((_vm.numList),function(v){return _c('div',{ref:"num",refInFor:true,staticClass:"num fl"})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }